import CryptoJS from 'crypto-js';

const fileToSha1String = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = function (event) {
            try {
                var file_data = event.target.result;
                var hash = CryptoJS.SHA1(CryptoJS.lib.WordArray.create(new Uint8Array(file_data))).toString(CryptoJS.enc.Hex);
                resolve(hash);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = function (error) {
            reject(error);
        };
        reader.readAsArrayBuffer(file);
    });
};

export default fileToSha1String;
